
export enum AppDatatableTreeStatus {
    EXPANDED = "expanded",
    COLLAPSED = "collapsed",
    LOADING = "loading",
    DISABLED = "disabled"
}


// WEBPACK FOOTER //
// ./src/app/shared/datatable/enums/tree-status.enum.ts